import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {Injectable} from '@angular/core';
import {ConsultationModel} from '../consultation.model';
import {ConsultationSummaryConverter} from './consultationSummary.converter';
import {AgendaEventConverter} from '../../../../../../agenda/modules/event/api/entity/converter/agendaEventConverter';
import {
    AudioTranscriptionConverter
} from '../../../../../../common/audio/transcription/api/model/converter/audioTranscription.converter';

@Injectable({ providedIn: 'root' })
export class ConsultationConverter extends HttpModelConverter<ConsultationModel> {
    constructor(private consultationSummaryConverter: ConsultationSummaryConverter,
                private agendaEventConverter: AgendaEventConverter,
                private audioTranscriptionConverter: AudioTranscriptionConverter) {
        super();
    }
    protected createInstance(): ConsultationModel {
        return new ConsultationModel();
    }

    protected enrichObject(result: ConsultationModel, src: ConsultationModel) {
        result.summary = this.consultationSummaryConverter.convert(src.summary);
        result.event = this.agendaEventConverter.convert(src.event);
        result.audioTranscriptions = this.audioTranscriptionConverter.convertFromArray(src.audioTranscriptions);
    }
}
